import Vue from "vue";
import Vuex from "vuex";
import userAgent from "./modules/user_agent";
import popup from "./modules/popup";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    userAgent,
    popup
  }
});
